module.exports = __webpack_public_path__ + "img/IMG_1847.3bb48f58.jpg";